<template>
  <TabBar gap="gap-0" data-testid="reviews-product-tabs">
    <NavTabBarItem
      :disabled="disabled"
      :is-selected="route.meta?.tabId === ReviewsProductRouteTabs.Details"
      :to="{ name: ReviewsRouteName.ReviewsProductViewDetails }"
      data-testid="reviews-tab-details"
    >
      {{ t('Reviews.product.view.tab.details') }}
    </NavTabBarItem>
    <NavTabBarItem
      :disabled="disabled"
      :is-selected="route.meta?.tabId === ReviewsProductRouteTabs.GlobalFeatures"
      :to="{ name: ReviewsRouteName.ReviewsProductViewGlobalFeatures }"
      data-testid="reviews-tab-global-features"
    >
      {{ t('Reviews.product.view.tab.globalFeatures') }}
    </NavTabBarItem>
    <NavTabBarItem
      :disabled="disabled"
      :is-selected="route.meta?.tabId === ReviewsProductRouteTabs.Pricing"
      :to="{ name: ReviewsRouteName.ReviewsProductViewPricing }"
      data-testid="reviews-tab-pricing"
    >
      {{ t('Reviews.product.view.tab.pricing') }}
    </NavTabBarItem>
    <NavTabBarItem
      :disabled="disabled"
      :is-selected="route.meta?.tabId === ReviewsProductRouteTabs.Assets"
      :to="{ name: ReviewsRouteName.ReviewsProductViewAssets }"
      data-testid="reviews-tab-assets"
    >
      {{ t('Reviews.product.view.tab.assets') }}
    </NavTabBarItem>
  </TabBar>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

import { ReviewsRouteName, ReviewsProductRouteTabs } from '@/router/types'
import { TabBar, NavTabBarItem } from '@/ui/Tabs'

const { t } = useI18n()
const route = useRoute()

const disabled = computed(() => {
  return route.name?.toString().startsWith(ReviewsRouteName.ReviewsProductEdit)
})
</script>
